<template>
  <div>
    
    <div style="margin-top: 50px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <div 
            style="margin-top: 50px; display: flex; 
            flex-direction: column; 
            width: 400px; 
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); 
            padding: 20px;
            justify-content: center; align-items: center;">

                <img alt="Easy Tailor App Logo" :src="getTopLogo" style="max-width: 150px; ">

                <div style="margin-top: 50px; display: flex; flex-direction: column; width: 80%;  justify-content: flex-start; align-items: flex-start;">
                    <span type="label">Email Address / User Name</span>
                    <el-input @focus="$event.target.select()"
                        id="loginId"
                        v-model.trim="$store.state.master.login.user_name" @keyup.enter.native="login">
                    </el-input>
                </div>
                <div style="margin-top: 20px; display: flex; flex-direction: column; width: 80%;  justify-content: flex-start; align-items: flex-start;">
                    <span type="label">Password</span>
                    <el-input @focus="$event.target.select()"
                        id="loginPassword"
                        type="password"
                        show-password
                        v-model.trim="$store.state.master.login.password" @keyup.enter.native="login">
                    </el-input>
                </div>

                <div style="margin-top: 20px; display: flex; flex-direction: row; width: 80%;  justify-content: space-between; align-items: space-between;">
                    <el-button :loading="$store.getters.getLoadingState" @click="login" type="primary" size="small">Login</el-button>
                    <el-link @click="$router.push('/forgotpassword')">Forgot Password?</el-link>                        
                </div>

                <div v-if="!isMasterLoginHidden" style="margin-top: 20px; display: flex; flex-direction: row; width: 80%;  justify-content: flex-start; align-items: flex-start;">
                    <el-link @click="$router.push('/signup')">Register New Account?</el-link>                        
                </div>

                <div v-if="!isMasterLoginHidden" style="margin-top: 20px; display: flex; flex-direction: row; width: 80%;  justify-content: flex-start; align-items: flex-start;">
                    <el-link @click="$router.push('/masteraccount')">Master Account</el-link>                        
                </div>

               <!--<div v-if="!isMobileDevice" style="width: 100%; text-align: center; margin-top: 50px;">
                    <span>
                        For new Easy Tailor App account, please <el-link href="https://easytailorapp.com/contactus"><b>contact us</b></el-link>.
                    </span>
                </div>
            -->
        </div>
    </div>
        
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';

export default {
    data() {
        return {
            processing: false,
            hideMasterLogin: true
        }
    },
    computed: {
        getTopLogo() {
            let logo = localStorage.getItem('default_logo')
            if(logo !== null) {
                if(logo.length === 0) {
                    logo = "https://etacdn.b-cdn.net/eta-new-logo.pngg"
                }
            } else {
                logo = "https://etacdn.b-cdn.net/white-blank.png"
            }
            return logo
        },
        isMobileDevice() {
            return isMobile
        },
        isProcessing() {
            return this.processing
        },
        isMasterLoginHidden() {
            return this.hideMasterLogin
        },
        getDeviceTokenId() {
            return localStorage.getItem('device_token_id')
        },
        getCurrentHostName() {
            return window.location.hostname
        },
        isHomeDomain() {
            return this.getCurrentHostName.includes('cloud.easytailor') || this.getCurrentHostName.includes('localhost')
        }
    },
    methods: {
        async login() {
            
            if(this.$store.state.master.login.user_name.length === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Email address or user id is missing', type: 'Error'})    
                document.getElementById('loginId').focus()
                return
            } else if(this.$store.state.master.login.password.length === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Password is missing', type: 'Error'})    
                document.getElementById('loginPassword').focus()
                return
            }

            this.processing = true

            let payload = this.$store.getters.getLoginProps
            payload.machine_id = this.$store.getters.getMachineId
            payload.device_token_id = this.getDeviceTokenId

            await this.$store.dispatch('login', payload)

            setTimeout(() => {
                this.processing = false
            }, 1000);
        }
    },

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Session/Login.vue